import React from "react";
import { Box } from "@chakra-ui/react"

const Browse = () => {
  const htmlContent = `
   <html>
      <head>
        <title>Browse Page</title>
          <script src="https://cdn.tailwindcss.com"></script>
    <style type="text/tailwindcss">
           @layer utilities {
         .content-auto {
        content-visibility: auto;
      }
    }
  </style>
  <style>
    
  </style>
      </head>
      <body>
        <section class="text-gray-600 body-font">
  <div class="container px-5 py-24 mx-auto">
    <div class="text-center mb-20">
      <h1 class="sm:text-3xl text-2xl font-medium text-center title-font text-gray-900 mb-4">Udyog Manufacturers List</h1>
      <p class="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">Discover a thriving marketplace designed to connect you with thousands of healthcare professionals and businesses across India.</p>
    </div>
    <div class="flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
      <div class="p-2 sm:w-1/4 w-full">
        <div class="bg-gray-100 rounded flex p-4 h-full items-center">
          <span class="title-font font-medium">Manufacturer 1</span>
        </div>
      </div>
      <div class="p-2 sm:w-1/4 w-full">
        <div class="bg-gray-100 rounded flex p-4 h-full items-center">
          <span class="title-font font-medium">Manufacturer 2</span>
        </div>
      </div> 
      <div class="p-2 sm:w-1/4 w-full">
        <div class="bg-gray-100 rounded flex p-4 h-full items-center">
          <span class="title-font font-medium">Manufacturer 3</span>
        </div>
      </div> 
      <div class="p-2 sm:w-1/4 w-full">
        <div class="bg-gray-100 rounded flex p-4 h-full items-center">
          <span class="title-font font-medium">Manufacturer 4</span>
        </div>
      </div> 
      <div class="p-2 sm:w-1/4 w-full">
        <div class="bg-gray-100 rounded flex p-4 h-full items-center">
          <span class="title-font font-medium">Manufacturer 5</span>
        </div>
      </div> 
      <div class="p-2 sm:w-1/4 w-full">
        <div class="bg-gray-100 rounded flex p-4 h-full items-center">
          <span class="title-font font-medium">Manufacturer 6</span>
        </div>
      </div> 
      <div class="p-2 sm:w-1/4 w-full">
        <div class="bg-gray-100 rounded flex p-4 h-full items-center">
          <span class="title-font font-medium">Manufacturer 7</span>
        </div>
      </div> 
      <div class="p-2 sm:w-1/4 w-full">
        <div class="bg-gray-100 rounded flex p-4 h-full items-center">
          <span class="title-font font-medium">Manufacturer 8</span>
        </div>
      </div> 
      <div class="p-2 sm:w-1/4 w-full">
        <div class="bg-gray-100 rounded flex p-4 h-full items-center">
          <span class="title-font font-medium">Manufacturer 9</span>
        </div>
      </div>
    </div>
    <button class="flex mx-auto mt-16 text-white bg-red-500 border-0 py-2 px-8 focus:outline-none hover:bg-red-600 rounded text-lg">For More Details Contact us</button>
  </div>
</section>
</body>
</html>
 
  `;

  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};

export default Browse;